export default __webpack_public_path__ + "static/media/T211447930_g.5b80fbbb.jpg";